export default __webpack_public_path__ + "static/jacekb-73ce2e25a88ed54679cde84875773eae.png";